import { makeStyles } from '@mui/styles';

export const modePatternsStyle = makeStyles(() => ({
    smallInput: {
        width: '50px',
        height: '36px',
        border: '1px solid #347AF0',
        borderRadius: '4px',
        padding: '0 5px',
        background: 'white',
        '&:disabled': { borderColor: '#A3B2BD' },
    },
    days: {
        fontSize: '16px',
        fontWeight: '500',
        color: '#4B5C68',
        marginLeft: '8px',
        marginRight: '8px',
    },
    dailyBoxStyle: {
        display: 'flex',
        alignItems: 'center',
    },
    patternBoxStyle: {
        display: 'flex',
        alignItems: 'center',
    },
    weeks: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#4B5C68',
        marginRight: '8px',
    },
    formGroup: {
        display: 'flex',
        flexDirection: 'row',

        '& .MuiRadio-colorSecondary.Mui-checked': {
            color: '#0C66E4 !important',
        },
        // '& span':{
        //    fontSize: 14
        // },

        '& .MuiIconButton-label': {
            color: '#347AF0',
        },
        '& .MuiTypography-body1': {
            fontSize: '14px',
            fontWeight: '600',
            color: '#4B5C68',
        },
    },
}));
